import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import SzukajJednorazowychForm from "../../konfiguracja/biletyConfig/biletyJednorazowe/components/SzukajJednorazowychForm";
import moment from "moment";
import BiletyService from "../../konfiguracja/biletyConfig/biletyApi/BiletyService";
import DateAndTimeUtilities from "../../../utilities/DateAndTimeFormat";
import TrasyService from "../../konfiguracja/trasyConfig/trasy/TrasyService";
import UrzadBiletyJednorazoweTable from "./compontents/UrzadBiletyJednorazoweTable";
import UrzadService from "../UrzadService";

export default class UrzadBiletyJednorazoweContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bilety: [],
            params: {
                dataOd: moment(),
                dataDo: moment(),
                czyDataSprzedazy:true
            },
            paramsObsady:null
        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    componentDidMount(){
        this.pobierzBilety(this.state.params)
        this.setState({paramsObsady:null})
    }

    pobierzBilety(params) {
        UrzadService.getBiletyJednorazowe(
            DateAndTimeUtilities.formatYYYYMMDD(params.dataOd),
            DateAndTimeUtilities.formatYYYYMMDD(params.dataDo),
            true
        ).then(function (response) {
            this.setState({bilety: response.data})
        }.bind(this))
    }

    onClickSzukaj(params) {
        this.setState({params:params})
        this.pobierzBilety(params)
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'UrzadContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/urzad', text: 'Urząd'},{addressUrl: '/urzad/jednorazowe', text: 'Bilety jednorazowe'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz} history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <SzukajJednorazowychForm handleClickSzukaj={this.onClickSzukaj} paramsObsady={this.state.paramsObsady} ukryjPrzyciskDodaj={true} wyswietlanieDlaUrzedu={true}/>
                        </Col>
                        <Col xs={12}>
                            <UrzadBiletyJednorazoweTable
                                data={this.state.bilety}
                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/bilety_jednorazowe/UrzadBiletyJednorazoweContainer.js